export default __webpack_public_path__ + "static/about-logo-d32503b03be6526e096f2a85f3e9dce6.gif";